import {
  ResidualValueSearchFormValues,
  ResidualValueEditFormValues,
  ResidualValueDetailFormValues,
  ResidualValueTable,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - RESIDUAL VALUE SEARCH
---------------------------------------------------------------------------------------------*/
export const initialResidualValueSearchForm: ResidualValueSearchFormValues = {
  search: "",
};

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - RESIDUAL VALUE DETAIL
---------------------------------------------------------------------------------------------*/
export const initialResidualValueDetailForm: ResidualValueDetailFormValues = {
  id: null,
  name: null,
};

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - RESIDUAL VALUE EDIT
---------------------------------------------------------------------------------------------*/

export const initialResidualValueEditForm: ResidualValueEditFormValues = {
  name: null,
};

/*-------------------------------------------------------------------------------------------
    CALCULATION SETTING - RESIDUAL VALUE EDIT
---------------------------------------------------------------------------------------------*/

export const initialResidualValueTable: ResidualValueTable = {
  id: null,
  name: null,
  kms: [],
  months: [],
  values: [],
};
